export interface ConfigState {
  data: any;
}

export const initialState: ConfigState = {
  data: {},
};
